import Wrapper from "../../../layout/Wrapper";
import CaseStatementContractManageComponent from "../../../screens/contractControll/caseIdiomsContract/manage";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Agent Management",
	description: "",
};

export default function AgentManage() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<CaseStatementContractManageComponent />
		</Wrapper>
	);
}